import {DataTransferObjectValidation} from "../../../type/Types";
import {ShoppingPathJointValueObject} from "../../vo/content/ShoppingPathJointValueObject";


export namespace ShoppingPathJointDataTransferObject {
    export type Post = {
        exposedAt: string
    }

    export namespace Post {
        export const description: Record<keyof ShoppingPathJointValueObject, string> = ShoppingPathJointValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            exposedAt(o: string): string | Error {
                try {
                    return new Date(o).toISOString().substring(0, 10)
                } catch (e) {
                    return new Error('exposedAt', { cause: e })
                }
            },
        }

    }

    export type PatchState = {
        wishState: boolean
    }

    export namespace PostByExposedAt {
        export const description: Record<keyof ShoppingPathJointValueObject, string> = ShoppingPathJointValueObject.description

        export const validation: DataTransferObjectValidation<PatchState> = {
            wishState(o: string): boolean {
                return Boolean(o)
            },
        }
    }
}

